export function compareRender(prevProps: any, nextProps: any, key = 'value') {
    return prevProps[key] === nextProps[key]
}